import React from 'react';
import { Typography, Button, Grid } from '@material-ui/core';

const SuksesInskryf = (props) =>
{

    return (
        <Grid container justify="center">
            <Grid item sm={12} lg={12}>
                <Grid container justify="center">
                    <Typography variant="h1">Inskrywing suksesvol!</Typography>
                </Grid>
            </Grid>
            <Grid item sm={12} lg={12}>
                <Grid container justify="center">
                    <Button onClick={() => { window.setTimeout(window.location.replace("https://lede.atkv.org.za"), 500); }} variant="contained" color="primary">Terug na ATKV-Lede webwerf</Button>
                </Grid>
            </Grid>
        </Grid>
        )

}

export default SuksesInskryf;




// WEBPACK FOOTER //
// ./src/components/SuksesInskryf.js